import React, { useEffect, useState } from "react";
import Oath from "./components/oath";
import Survey from "./components/Survey";
import About from "./components/about";
import Background from "./components/background";
import Expert from "./components/expert";
import ExpertInfo from "./components/expertInfo";
import Professions from "./components/professions";
import Expertises from "./components/expertises";
import DocumentsUpload from "./components/DocumentsUpload";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getExpertData } from "../../service/api";
import { Spin } from "antd";
import Resume from "../contentPage/components/resume/Resume";
import Warning from "./components/Warning";
import RejectWarning from "./components/RejectWarning";
import BankInfo from "./components/BankInfo";
import Others from "./components/Others";

function PersonalPage() {
  const [expertData, setExpertData] = useState();
  const [warning, setWarning] = useState(true);
  const [modifyWarning, setModifyWarning] = useState();
  const expertDataQuery = useQuery(["expertData"], getExpertData);
  const queryClient = useQueryClient();

  let googleScholarURL = expertData?.googleScholarURL;
  let researchGateURL = expertData?.researchGateURL;
  let otherSocialNetworkURL = expertData?.otherSocialNetworkURL;
  let resume = expertData?.resume;
  useEffect(()=>{
    queryClient.invalidateQueries(["expertData"]);
  },[])
  useEffect(() => {
    if (expertDataQuery?.data) {
      
      if (expertDataQuery?.data?.modifiedExpert) {
        setModifyWarning(true);
        const mergedExpertData = expertDataQuery?.data?.expert;
        Object.entries(expertDataQuery?.data?.modifiedExpert).forEach(
          ([key, value]) => {
            if (value !== "NOT_MODIFIED") {
              mergedExpertData[key] = value;
            }
          }
        );
        setExpertData(mergedExpertData);
      } else {
        setExpertData(expertDataQuery?.data?.expert);
      }
    }
  }, [expertDataQuery?.data ]);

  return (
    <Spin
      size="large"
      className="absolute mt-52 w-[1000px]"
      spinning={expertDataQuery?.isLoading}
    >
      {expertDataQuery?.isSuccess && (
        <div className=" flex flex-col gap-4 p-8 mx-14 my-4 bg-[#E7EDF3] max-lg:p-2 max-lg:my-0 max-lg:mx-0 ">
          {warning && <Warning setWarning={setWarning} />}
          {modifyWarning && (
            <RejectWarning
              expertDataQuery={expertDataQuery}
              setModifyWarning={setModifyWarning}
            />
          )}

          <Background data={expertData}  expertDataQuery={expertDataQuery?.data}/>
          <Expert isLoading={expertDataQuery.isLoading} data={expertData} />
          <ExpertInfo info={expertData} />
          <About note={expertData?.aboutMe} />
          <div className="flex flex-row gap-4 max-lg:flex-col opacity-80 brightness-90">
            <Oath Name={expertData?.firstName + " " + expertData?.lastName} />
            <Survey data={expertData?.survey} />
          </div>
          <div className="flex flex-row gap-4 max-lg:flex-col">
            <Professions data={expertData} />
            <Expertises data={expertData} />
          </div>
          <DocumentsUpload data={expertData} />
          <div>
            <Resume
            
              data={{
                googleScholarURL,
                researchGateURL,
                otherSocialNetworkURL,
                resume,
                expertDataQuery
              }}
            />
          </div>
          <BankInfo expertData={expertDataQuery?.data}/>
          <Others expertData={expertDataQuery?.data}/>
        </div>
      )}
    </Spin>
  );
}

export default PersonalPage;
